import { fork, all } from 'redux-saga/effects';
import cartSaga from './cart';
import userSaga from './user';
import orderSaga from './order';
import addressSaga from './address';
import productSaga from './product';
import couponSaga from './coupon';
import groupSaga from './group';
import specialSaga from './special';
import popupSaga from './popup';
import guideSaga from './guide';
import appointSaga from './appoint';
import arSaga from './ar';

export default function* mallSaga() {
  yield all([
    fork(cartSaga),
    fork(userSaga),
    fork(orderSaga),
    fork(addressSaga),
    fork(productSaga),
    fork(couponSaga),
    fork(groupSaga),
    fork(specialSaga),
    fork(popupSaga),
    fork(guideSaga),
    fork(appointSaga),
    fork(arSaga),
  ]);
}
